import ApiService from '../../infrastructure/api/ApiService';
import { ApiResponse } from '../models/api';

/**
 * Kullanıcı işlemleri için servis sınıfı
 */
export class UserService {
  private static instance: UserService;

  private constructor() {
    // Constructor
  }

  /**
   * Singleton instance al
   */
  public static getInstance(): UserService {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }
    return UserService.instance;
  }

  /**
   * Şifre yenileme işlemi
   * @param token Şifre yenileme token'ı
   * @param password Yeni şifre
   * @param email Kullanıcı email adresi (opsiyonel)
   */
  public async resetPassword(token: string, password: string, email?: string): Promise<ApiResponse<any>> {
    try {
      const endpoint = '/user-resource-service/api/v1/users/reset-password';
      
      // İstek parametreleri
      const data: any = { token, password };
      
      // Email parametresi varsa ekle
      if (email) {
        data.email = email;
      }
      
      const response = await ApiService.post(endpoint, data);

      return {
        success: response.success,
        data: response.data,
        statusCode: response.statusCode
      };
    } catch (error: any) {
      console.error('Şifre yenileme isteği başarısız oldu:', error);

      // HTTP durum koduna ve hata koduna göre çeviri anahtarı belirle
      let errorKey = 'errors:resetPassword.defaultError';
      const statusCode = error.response?.status || 500;
      const errorCode = error.response?.data?.errorCode;

      // Durum kodu ve hata koduna göre uygun çeviri anahtarını belirle
      if (statusCode === 400) {
        if (errorCode === 'INVALID_TOKEN') {
          errorKey = 'errors:resetPassword.invalidToken';
        } else if (errorCode === 'PASSWORD_POLICY_VIOLATION') {
          errorKey = 'errors:resetPassword.passwordPolicyViolation';
        } else {
          errorKey = 'errors:resetPassword.badRequest';
        }
      } else if (statusCode === 401 || statusCode === 403) {
        errorKey = 'errors:resetPassword.unauthorized';
      } else if (statusCode === 404) {
        errorKey = 'errors:resetPassword.notFound';
      } else if (statusCode === 410) {
        errorKey = 'errors:resetPassword.expired';
      } else if (statusCode >= 500) {
        errorKey = 'errors:resetPassword.serverError';
      }

      return {
        success: false,
        error: errorKey,
        statusCode: statusCode,
        errorCode: errorCode
      };
    }
  }

  /**
   * Requests a password reset email (forgot password).
   * @param email User's email address
   */
  public async forgotPassword(email: string): Promise<ApiResponse<any>> {
    try {
      const endpoint = '/user-resource-service/api/v1/users/forgot-password';
      const response = await ApiService.post(endpoint, { email });
      return {
        success: response.success,
        data: response.data,
        statusCode: response.statusCode
      };
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.message || 'errors:forgotPassword.defaultError',
        statusCode: error.response?.status || 500,
      };
    }
  }

  /**
   * Hesap doğrulama işlemi
   * @param confirmationId Doğrulama ID'si
   */
  public async confirmAccount(confirmationId: string): Promise<ApiResponse<any>> {
    try {
      const endpoint = '/user-resource-service/api/v1/temp-users/verify';
      const data = {
        validation_code: confirmationId
      };
      const response = await ApiService.post(endpoint, data);

      return {
        success: response.success,
        data: response.data,
        statusCode: response.statusCode
      };
    } catch (error: any) {
      console.error('Hesap doğrulama isteği başarısız oldu:', error);

      // HTTP durum koduna ve hata koduna göre çeviri anahtarı belirle
      let errorKey = 'errors:confirmation.defaultError';
      const statusCode = error.response?.status || 500;
      const errorCode = error.response?.data?.errorCode;

      // Durum kodu ve hata koduna göre uygun çeviri anahtarını belirle
      if (statusCode === 400) {
        if (errorCode === 'INVALID_CONFIRMATION_ID') {
          errorKey = 'errors:confirmation.invalidId';
        } else {
          errorKey = 'errors:confirmation.badRequest';
        }
      } else if (statusCode === 401 || statusCode === 403) {
        errorKey = 'errors:confirmation.unauthorized';
      } else if (statusCode === 404) {
        errorKey = 'errors:confirmation.notFound';
      } else if (statusCode === 410) {
        errorKey = 'errors:confirmation.expired';
      } else if (statusCode >= 500) {
        errorKey = 'errors:confirmation.serverError';
      }

      return {
        success: false,
        error: errorKey,
        statusCode: statusCode,
        errorCode: errorCode
      };
    }
  }
}

// Singleton instance export et
export default UserService.getInstance();
 